import { http, HttpResponse } from 'msw';

const handlers = [
  http.get('/api/v1/agent.sh', () => {
    return HttpResponse.text('script');
  }),
];

export default handlers;
